import { mainApi } from '../../../../../api/mainApi';
import { AccessState } from '../../../../../types';
import { middlewareApi } from '../../../../middleware/middlewareApi';
import { MeetingsResponse } from '../interfaces/meetings.interface';

export const studentMeetingsTags = middlewareApi.enhanceEndpoints({
  addTagTypes: ['Meetings', 'StudentMeetings'],
});
// Define a service using a base URL and expected endpoints
export const studentMeetingsApi = studentMeetingsTags.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * @GET all meetings course for student
     */
    getStudentCourseMeetings: builder.query<
      MeetingsResponse,
      {
        profileId?: number;
        page: number;
        perPage: number;
        courseId: number;
        studentId: number;
      }
    >({
      queryFn: async ({ page, perPage, profileId, courseId, studentId }, { getState }) => {
        try {
          const {
            access: { currentProfile },
          } = getState() as { access: AccessState };

          const user_profile_id = profileId || currentProfile?.profileId;

          const { data } = await mainApi.get<MeetingsResponse>(
            `/courses/${courseId}/activities/students/${studentId}/mettings`,
            {
              params: {
                user_profile_id,
                page,
                size: perPage,
                sort: 'id',
                type_sort: 'desc',
                // data: 'all',
              },
            }
          );

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      providesTags: (result) =>
        result
          ? [
              ...result.data.map((value) => ({ type: 'Meetings', id: value.id } as const)),
              { type: 'Meetings', id: 'LIST' },
            ]
          :
           [{ type: 'Meetings', id: 'LIST' }],
    }),

    //
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetStudentCourseMeetingsQuery } = studentMeetingsApi;
